import React from "react";
import { Link, useNavigate } from "react-router-dom";

// icons
import { TbError404 } from "react-icons/tb";

// images
// import Logo from "../../components/Logo";

function Login() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100dvh",
        width: "100dvw",
        padding: 10,
      }}
    >
      <div
        style={{
          flex: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TbError404 style={{ width: "400px", height: "200px" }} />
        <div style={{ fontSize: 32, fontWeight: 700 }}>Page not found !</div>
        <Link to="/">
          <a style={{ fontSize: 22 }}>{">> back to home <<"}</a>
        </Link>
      </div>

      {/* spase */}
      <div style={{ flex: 2 }} />
      {/* Footer section  ------------------------------------------------------------------------------------------ */}
      <div
        style={{
          textAlign: "center",
          fontSize: 14,
          opacity: 0.7,
        }}
      >
        Copyright © 2024 therdy.co
      </div>
    </div>
  );
}

export default Login;
